import type { QuestExportEnvelope, QuestState } from "./types";
import { stableStringify } from "./stableJson";

export async function createQuestExportEnvelope(params: {
  appVersion: string;
  exportedAt: string;
  routeCatalogVersion: string;
  payload: QuestState;
}): Promise<QuestExportEnvelope> {
  const unsigned = {
    schemaVersion: 1,
    appVersion: params.appVersion,
    exportedAt: params.exportedAt,
    routeCatalogVersion: params.routeCatalogVersion,
    payload: params.payload,
  };
  return {
    ...unsigned,
    checksum: await checksumForExport(unsigned),
  };
}

export async function verifyQuestExportEnvelope(
  envelope: QuestExportEnvelope,
): Promise<boolean> {
  const { checksum: _checksum, ...unsigned } = envelope;
  return envelope.checksum === (await checksumForExport(unsigned));
}

export async function checksumForExport(value: unknown): Promise<string> {
  const input = stableStringify(value);
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.subtle) {
    const bytes = new TextEncoder().encode(input);
    const digest = await cryptoApi.subtle.digest("SHA-256", bytes);
    return `sha256-${Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("")}`;
  }
  return fallbackChecksum(input);
}

function fallbackChecksum(input: string): string {
  let hash = 0x811c9dc5;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return `fnv1a-${(hash >>> 0).toString(16).padStart(8, "0")}`;
}
